import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Typo.scss';

import Modal from '../../UI/Modal/Modal.jsx';
import Button from '../../UI/Button/Button.jsx';

import apiFetch from '../../../utils/fetch';
import Toast from '../../../components/modal/toast';

/**
 * @class
 * @classdesc Модальное окно Отчет о найденной опечатке
 */

class Typo extends Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.action = '/typo/find';

        this.state = {
            closed: true,
            range: null,
            comment: '',
            submitting: false,
            error: null,
            success: false
        };

        this.openTypoPopup = this.openTypoPopup.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }

    openTypoPopup(selection) {
        this.setState({
            closed: false,
            range: selection.getRangeAt(0)
        });
    }

    getEntity() {
        if (!this.state.range) return null;

        let startSelectionEntity = this.state.range.startContainer.parentElement.closest(
            '[data-id]'
        );
        let endSelectionEntity = this.state.range.endContainer.parentElement.closest(
            '[data-id]'
        );

        if (
            !startSelectionEntity ||
            startSelectionEntity !== endSelectionEntity
        )
            return null;

        return startSelectionEntity.dataset.id;
    }

    closeHandler() {
        this.setState({
            closed: true
        });
    }

    submitHandler(event) {
        event.preventDefault();
        this.setState({
            submitting: true
        });
        apiFetch({
            url: this.action,
            params: {
                typo: this.state.range.toString(),
                url: window.location.href,
                comment: this.state.comment,
                id: this.getEntity()
            }
        })
            .then(response => {
                if (response.success) {
                    this.setState({
                        closed: true,
                        range: null,
                        comment: '',
                        error: null
                    });
                    Toast.open('Отчет об опечатке отправлен', {
                        state: 'success'
                    });
                } else {
                    this.setState({
                        error: response.error || 'Не удалось отправить отчет :('
                    });
                }
            })
            .finally(() => {
                this.setState({
                    submitting: false
                });
            });
    }

    changeCommentHandler(value) {
        this.setState({
            comment: value
        });
    }

    componentDidMount() {
        document.addEventListener('keydown', e => {
            if (e.code === 'Enter' && e.ctrlKey) {
                let selection = window.getSelection();
                if (selection.toString()) {
                    this.openTypoPopup(selection);
                }
            }
        });
    }

    render() {
        let content = 'Ничего не выделено';
        if (this.state.range) {
            content = this.state.range.toString();
        }

        return (
            <Modal
                size='large'
                closed={this.state.closed}
                title='Нашли опечатку?'
                onClose={this.closeHandler}
            >
                <div className='typo-form'>
                    <div className='typo-form__content'>{content}</div>
                    <form onSubmit={this.submitHandler}>
                        <textarea
                            className='textarea'
                            value={this.state.comment}
                            onChange={e =>
                                this.changeCommentHandler(e.target.value)
                            }
                            placeholder='Комментарий'
                        ></textarea>
                        <Button
                            type='submit'
                            modes={['accent']}
                            loading={this.state.submitting}
                        >
                            Отправить
                        </Button>
                    </form>
                    {this.state.error ? (
                        <div className='color-error mt-2'>{this.state.error}</div>
                    ) : null}
                </div>
            </Modal>
        );
    }
}

export default Typo;
